import apiClient from './apiClient';
import { Session } from '../structures/response/Session';

export interface SettingsItem {
  key: string;
  value: string;
}

export const getSettingsParam = (key: string): Promise<SettingsItem> =>
  apiClient.get(`account/settings/get?key=${key}`).then((r) => r.data);

export const setSettingsParam = (key: string, value: string): Promise<void> =>
  apiClient.post(`account/settings/set`, { key, value }).then((r) => r.data);

export const sessionList = async (): Promise<Session[]> =>
  apiClient.get(`account/session/list`).then((r) => r.data);

export const sessionClose = async (sessionId: number): Promise<void> =>
  apiClient
    .post(`account/session/close?sessionId=${sessionId}`)
    .then((r) => r.data);

export const sessionCloseAll = async (): Promise<void> =>
  apiClient.post(`account/session/close-all`).then((r) => r.data);
